import { sensorsMonitor } from '@/utils/utils';

const distinctId = sensorsMonitor().store.getDistinctId();
export default [
  {
    name: 'rsrush',
    appName: 'RsRush',
    country: 'IN',
    areaCode: '91',
    regexp: /^[6-9]\d{9}$/,
    phoneLength: 12, // 这里的长度是 加上空格的长度
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=cash.rupee.credit.loan.india',
    termsOfUse: 'https://rsrush.cc/terms-of-use/',
    privacyPolicy: 'https://rsrush.cc/privacy-policy/',
    branchKey: 'key_live_fnJQu6A1I7rmpgHNZs7BBekhrwjUXZdR',
  },
  {
    name: 'rskash',
    appName: 'RSKASH',
    country: 'IN',
    areaCode: '91',
    regexp: /^[6-9]\d{9}$/,
    phoneLength: 12, // 这里的长度是 加上空格的长度
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=cash.rupee.credit.loan.india.money',
    termsOfUse: 'https://rskash.com/terms-of-use/',
    privacyPolicy: 'https://rskash.com/privacy-policy/',
    header: {
      App_id: 'cash.rupee.credit.loan.india.money',
      App_name: 'RSKASH',
      distinctId,
    },
    params: {
      registerChannel: 'h5',
      appVersion: '1.0.0',
      appName: 'RSKASH',
      appId: 'cash.rupee.credit.loan.india.money',
    },
    branchKey: 'key_live_ekIY3c8sS24iHpmnlsuTGnnlCqjZOVuj',
  },
  {
    name: 'xcredit',
    appName: 'XCredit',
    country: 'NG',
    areaCode: '234',
    regexp: /^0[7|8|9]\d{9}$/,
    phonePlaceholder: 'xxx-xxxx-xxxx',
    phoneLength: 13,
    download: 'https://play.google.com/store/apps/details?id=com.xcredit.loan.nigeria&hl=zh',
    termsOfUse: 'https://xcredit.cc/?page_id=366',
    privacyPolicy: 'https://xcredit.cc/?page_id=354',
    i18n: 'en_US',
    header: { // xcredit & imoney需要添加请求头
      App_id: 'com.xcredit.loan.nigeria',
      App_name: 'XCredit',
      distinctId,
    },
    params: { // xcredit & imoney需要多加一些参数
      appId: 'com.xcredit.loan.nigeria',
      appName: 'XCredit',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_nmTw5dD1CApB3NJf5D2kHbocqtdj17RJ',
  },
  {
    name: 'imoney',
    appName: 'iMoney',
    country: 'NG',
    areaCode: '234',
    regexp: /^0[7|8|9]\d{9}$/,
    phonePlaceholder: 'xxx-xxxx-xxxx',
    phoneLength: 13,
    download: 'https://play.google.com/store/apps/details?id=com.imoney.credit.nira&hl=en',
    termsOfUse: 'https://imoney.ng/?page_id=23',
    privacyPolicy: 'https://imoney.ng/?page_id=208',
    i18n: 'en_US',
    header: { // xcredit & imoney需要添加请求头
      App_id: 'com.imoney.credit.nira',
      App_name: 'iMoney',
      distinctId,
    },
    params: { // xcredit & imoney需要多加一些参数
      appId: 'com.imoney.credit.nira',
      appName: 'iMoney',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_phQI201DAO73BUvM1jj8QmhfzwipgQ5o',
  },
  {
    name: '_9jacash',
    appName: '9jaCash',
    country: 'NG',
    areaCode: '234',
    regexp: /^0[7|8|9]\d{9}$/,
    phonePlaceholder: 'xxx-xxxx-xxxx',
    phoneLength: 13,
    download: 'https://play.google.com/store/apps/details?id=com.jacash.personal.loan.instant&hl=en',
    termsOfUse: 'https://9jacash.cc/terms-of-use/',
    privacyPolicy: 'https://9jacash.cc/privacy-policy/',
    i18n: 'en_US',
    header: { // xcredit & imoney需要添加请求头
      App_id: 'com.jacash.personal.loan.instant',
      App_name: '9jaCash',
      distinctId,
      strategy: 'default'
    },
    params: { // xcredit & imoney需要多加一些参数
      appId: 'com.jacash.personal.loan.instant',
      appName: '9jaCash',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: '',
  },
  {
    name: 'nownowmoney',
    appName: 'nownowmoney',
    country: 'NG',
    areaCode: '234',
    regexp: /^0[7|8|9]\d{9}$/,
    phonePlaceholder: 'xxx-xxxx-xxxx',
    phoneLength: 13,
    download: 'https://play.google.com/store/apps/details?id=com.jacash.personal.loan.instant&hl=en',
    termsOfUse: 'https://nownowmoney.cc/terms-of-use/',
    privacyPolicy: 'https://nownowmoney.cc/privacy-policy/',
    i18n: 'en_US',
    header: { // xcredit & imoney需要添加请求头
      App_id: 'com.nownowmoney.loan.instant.cash',
      App_name: 'nownowmoney',
      distinctId,
      strategy: 'default'
    },
    params: { // xcredit & imoney需要多加一些参数
      appId: 'com.nownowmoney.loan.instant.cash',
      appName: 'nownowmoney',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: '',
  },


  {
    name: 'kashway',
    appName: 'Kashway',
    country: 'KE',
    areaCode: '254',
    regexp: /^[7|1]\d{8}$/,
    phoneLength: 11,
    i18n: 'en_US',
    header: {
      App_id: 'cash.pesa.loan.kenya',
      App_name: 'Kashway',
      distinctId,
    },
    phonePlaceholder: 'xxx-xxxx-xx',
    download: 'https://play.google.com/store/apps/details?id=cash.pesa.loan.kenya&hl=en',
    termsOfUse: 'https://kashway.cc/?page_id=75',
    privacyPolicy: 'https://kashway.cc/?page_id=49',
    branchKey: 'key_live_hfHGkW2X5UNx4JEpMY3g4bghyxdptrj3',
  },
  {
    name: 'creditmoja',
    appName: 'Creditmoja',
    country: 'KE',
    areaCode: '254',
    regexp: /^[7|1]\d{8}$/,
    phoneLength: 11,
    i18n: 'en_US',
    header: {
      strategy: 'default',
      App_id: 'com.kenya.credit.app.loan.cash.money.pesa',
      App_name: 'Creditmoja',
      distinctId,
    },
    phonePlaceholder: 'xxx-xxxx-xx',
    download: 'https://play.google.com/store/apps/details?id=com.kenya.credit.app.loan.cash.money.pesa&hl=en',
    termsOfUse: 'https://www.creditmoja.com/terms-of-use',
    privacyPolicy: 'https://www.creditmoja.com/privacy-policy',
    branchKey: 'key_live_jcWqcdFTOGXAsST3QESEcbflzqdfW5ml',
  },
  {
    name: 'ipesa',
    appName: 'Ipesa',
    country: 'KE',
    areaCode: '254',
    regexp: /^[7|1]\d{8}$/,
    phoneLength: 11,
    i18n: 'en_US',
    header: {
      App_id: 'com.xgo.credit',
      App_name: 'Ipesa',
      distinctId,
    },
    phonePlaceholder: 'xxx-xxxx-xx',
    download: 'https://play.google.com/store/apps/details?id=com.xgo.credit&hl=en',
    termsOfUse: 'https://ipesa.cc/?page_id=112',
    privacyPolicy: 'https://ipesa.cc/?page_id=114',
    branchKey: 'key_live_djKF9mn1BRrFTJypqGYMuedoBqkqAy68',
  },
  {
    name: 'tifislice',
    appName: 'tifislice',
    country: 'KE',
    areaCode: '254',
    regexp: /^[7|1]\d{8}$/,
    phoneLength: 11,
    i18n: 'en_US',
    header: {
      App_id: 'tifislice.loan.credit.cash.longterm',
      App_name: 'tifislice',
      distinctId,
    },
    phonePlaceholder: 'xxx-xxxx-xx',
    download: 'https://play.google.com/store/apps/details?id=tifislice.loan.credit.cash.longterm&hl=en',
    termsOfUse: 'https://tifislice.com/terms-of-use',
    privacyPolicy: 'https://tifislice.com/privacy-policy',
    branchKey: 'key_live_djKF9mn1BRrFTJypqGYMuedoBqkqAy68',
  },
  {
    name: 'ipeso',
    appName: 'iPeso',
    country: 'MX',
    areaCode: '52',
    regexp: /\d{10}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.ipeso.credit.mexico&hl=None',
    termsOfUse: 'https://ipeso.cc/terminos-de-uso/',
    privacyPolicy: 'https://ipeso.cc/politica-de-privacidad/',
    i18n: 'es_MX',
    header: {
      App_id: 'com.ipeso.credit.mexico',
      'Accept-Language': 'es',
      App_name: 'iPeso',
      distinctId,
    },
    params: {
      appId: 'com.ipeso.credit.mexico',
      appName: 'iPeso',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_igG7snoUN4ZZ61nzscf9uclnDtiM85wc',
  },
  {
    name: 'kabilcash',
    appName: 'KabilCash',
    country: 'MX',
    areaCode: '52',
    regexp: /\d{10}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.kabilcash.credit.fast.loan.cash.prestamo.mexico&hl=None',
    termsOfUse: 'https://kabilcash.com/terms-of-use',
    privacyPolicy: 'https://kabilcash.com/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.kabilcash.credit.fast.loan.cash.prestamo.mexico',
      'Accept-Language': 'es',
      strategy: 'default',
      App_name: 'Kabil Cash',
      distinctId,
    },
    params: {
      appId: 'com.kabilcash.credit.fast.loan.cash.prestamo.mexico',
      appName: 'Kabil Cash',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_nhYpiGJpd6QyMxeYl5JRycdmxqj1vH4r',
  },
  {
    name: 'creavicash',
    appName: 'Creavi Cash',
    country: 'MX',
    areaCode: '52',
    regexp: /\d{10}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.creavicash.credit.fast.loan.cash.prestamo.mexico&hl=None',
    termsOfUse: 'http://creavicash.com/terms-of-use',
    privacyPolicy: 'http://creavicash.com/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.creavicash.credit.fast.loan.cash.prestamo.mexico',
      'Accept-Language': 'es',
      strategy: 'default',
      App_name: 'Creavi Cash',
      distinctId,
    },
    params: {
      appId: 'com.creavicash.credit.fast.loan.cash.prestamo.mexico',
      appName: 'Creavi Cash',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_hpWhwyYWFjQyWdCLTVZP8icptChu4ZAP',
  },
  {
    name: 'maxcredito',
    appName: 'Maxcredito',
    country: 'MX',
    areaCode: '52',
    regexp: /\d{10}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.maxcredito.mexico.fast.cash.prestamo.loan&hl=None',
    termsOfUse: 'http://maxcredito.cc/terms-of-use',
    privacyPolicy: 'http://maxcredito.cc/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.maxcredito.mexico.fast.cash.prestamo.loan',
      'Accept-Language': 'es',
      strategy: 'default',
      App_name: 'Maxcredito',
      distinctId,
    },
    params: {
      appId: 'com.maxcredito.mexico.fast.cash.prestamo.loan',
      appName: 'Maxcredito',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_joZdAu25uaPLMfVigYMfqomjstgIAVof',
  },
  {
    name: 'creditaco',
    appName: 'Creditaco',
    country: 'MX',
    areaCode: '52',
    regexp: /\d{10}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.credit.taco.fast.loan.cash.prestamo.mexico',
    termsOfUse: 'http://creditaco.com/terms-of-use',
    privacyPolicy: 'http://creditaco.com/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.credit.taco.fast.loan.cash.prestamo.mexico',
      'Accept-Language': 'es',
      strategy: 'default',
      App_name: 'Creditaco',
      distinctId,
    },
    params: {
      appId: 'com.credit.taco.fast.loan.cash.prestamo.mexico',
      appName: 'Creditaco',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_pi3sCg3kcPTkVTOq7QKRldloxunyaoA6',
  },
  {
    name: 'xfectivo',
    appName: 'XFectivo',
    country: 'MX',
    areaCode: '52',
    regexp: /\d{10}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.loan.cash.credit.tala.fast.efectivo.prestamos.mexico&hl=None',
    termsOfUse: 'http://xfectivo.com/terms-of-use',
    privacyPolicy: 'http://xfectivo.com/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.loan.cash.credit.tala.fast.efectivo.prestamos.mexico',
      'Accept-Language': 'es',
      strategy: 'default',
      App_name: 'XFectivo',
      distinctId,
    },
    params: {
      appId: 'com.loan.cash.credit.tala.fast.efectivo.prestamos.mexico',
      appName: 'XFectivo',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_hp7nNU7E31qVkQb74gFlXcdiCxcNbC5M',
  },
  {
    name: 'icredito',
    appName: 'iCrédito',
    country: 'MX',
    areaCode: '52',
    regexp: /\d{10}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.loan.credit.branch.tala.fast.efectivo.prestamos.mexico&hl=None',
    termsOfUse: 'https://xcredito.cc/terms-of-use',
    privacyPolicy: 'https://xcredito.cc/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.loan.credit.branch.tala.fast.efectivo.prestamos.mexico',
      'Accept-Language': 'es',
      strategy: 'default',
      App_name: 'iCrédito',
      distinctId,
    },
    params: {
      appId: 'com.loan.credit.branch.tala.fast.efectivo.prestamos.mexico',
      appName: 'iCrédito',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_am7lTRXrZyLB2EXjH8tEZgdfuAkFcbG8',
  },
  {
    name: 'credifio',
    appName: 'Credifio',
    country: 'MX',
    areaCode: '52',
    regexp: /\d{10}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.loan.dinero.credit.fio.fast.efectivo.prestamos.mexico&hl=None',
    termsOfUse: 'https://credifio.com/terms-of-use',
    privacyPolicy: 'https://credifio.com/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.loan.dinero.credit.fio.fast.efectivo.prestamos.mexico',
      'Accept-Language': 'es',
      strategy: 'default',
      App_name: 'Credifio',
      distinctId,
    },
    params: {
      appId: 'com.loan.dinero.credit.fio.fast.efectivo.prestamos.mexico',
      appName: 'Credifio',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_ld0CdRZwHDAo8NK5QOYfvnkdDFlTIMEf',
  },

  // 西班牙
  {
    name: 'champloan',
    appName: 'ChampLoan',
    country: '西班牙',
    areaCode: '34',
    regexp: /^[6|7]\d{8}$/,
    phoneLength: 11,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.champ.loan.efectivo.credito.prestamos.spain',
    termsOfUse: 'https://champloan.es/terms-of-use',
    privacyPolicy: 'https://champloan.es/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.champ.loan.efectivo.credito.prestamos.spain',
      'Accept-Language': 'es',
      strategy: 'default',
      App_name: 'Champ loan',
      distinctId,
    },
    params: {
      appId: 'com.champ.loan.efectivo.credito.prestamos.spain',
      appName: 'Champ loan',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_joZdAu25uaPLMfVigYMfqomjstgIAVof',
  },

  // 尼日
  {
    name: 'credit9ja',
    appName: 'Credit9ja',
    country: 'NG',
    areaCode: '234',
    regexp: /^0[7|8|9]\d{9}$/,
    phonePlaceholder: 'xxx-xxxx-xxxx',
    phoneLength: 13,
    download: 'https://play.google.com/store/apps/details?id=com.credit9ja.cash.loan.fast.pay&hl=en',
    termsOfUse: 'https://credit9ja.cc/terms-of-use',
    privacyPolicy: 'https://credit9ja.cc/privacy-policy',
    i18n: 'en_US',
    header: {
      App_id: 'com.credit9ja.cash.loan.fast.pay',
      strategy: 'default',
      App_name: 'Credit9ja',
      distinctId,
    },
    params: {
      appId: 'com.credit9ja.cash.loan.fast.pay',
      appName: 'Credit9ja',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_og8ct9dllbcRu6HI1yCylhmiwqhJJT98',
  },
  {
    name: 'naira9ja',
    appName: 'Credit9ja',
    country: 'NG',
    areaCode: '234',
    regexp: /^0[7|8|9]\d{9}$/,
    phonePlaceholder: 'xxx-xxxx-xxxx',
    phoneLength: 13,
    download: 'https://play.google.com/store/apps/details?id=com.naira9ja.loan.credit.cash.borrow&hl=en',
    termsOfUse: 'https://naira9ja.cc/terms-of-use',
    privacyPolicy: 'https://naira9ja.cc/privacy-policy',
    i18n: 'en_US',
    header: {
      App_id: 'com.naira9ja.loan.credit.cash.borrow',
      strategy: 'default',
      App_name: 'Naira9ja',
      distinctId,
    },
    params: {
      appId: 'com.naira9ja.loan.credit.cash.borrow',
      appName: 'Naira9ja',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_og8ct9dllbcRu6HI1yCylhmiwqhJJT98',
  },

  {
    name: 'ucredit',
    appName: 'UCredit',
    country: 'UG',
    areaCode: '256',
    // regexp: /^[1-9]\d{8}$/, // 首数字不能为0
    regexp: /^7[0|4|5|6|7|8]\d{7}$/,
    phonePlaceholder: 'xxx-xxxx-xx',
    phoneLength: 11,
    download: 'https://play.google.com/store/apps/details?id=com.uganda.creditn.app.loan.cash.money&hl=en',
    termsOfUse: 'https://ucredit.cc/terms-of-use',
    privacyPolicy: 'https://ucredit.cc/privacy-policy',
    i18n: 'en_US',
    header: {
      App_id: 'com.uganda.creditn.app.loan.cash.money',
      strategy: 'default',
      distinctId,
    },
    params: {
      appId: 'com.uganda.creditn.app.loan.cash.money',
      appName: 'UCredit',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_ml0kMmdyocQ6dXJlv3HnNiebAseiZyxj',
  },
  {
    name: 'isente',
    appName: 'iSente',
    country: 'UG',
    areaCode: '256',
    // regexp: /^[1-9]\d{8}$/, // 首数字不能为0
    regexp: /^7[0|4|5|6|7|8]\d{7}$/,
    phonePlaceholder: 'xxx-xxxx-xx',
    phoneLength: 11,
    download: 'https://play.google.com/store/apps/details?id=com.uganda.creditn.app.loan.cash.money&hl=en',
    termsOfUse: 'https://isente.cc/terms-of-use',
    privacyPolicy: 'https://isente.cc/privacy-policy',
    i18n: 'en_US',
    header: {
      App_id: 'uganda.loan.credit.cash.borrow.isente',
      strategy: 'default',
      distinctId,
    },
    params: {
      appId: 'uganda.loan.credit.cash.borrow.isente',
      appName: 'iSente',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_ml0kMmdyocQ6dXJlv3HnNiebAseiZyxj',
  },


  {
    name: 'mangucash',
    appName: 'ManguCash',
    country: 'UG',
    areaCode: '256',
    // regexp: /^[1-9]\d{8}$/, // 首数字不能为0
    regexp: /^7[0|4|5|6|7|8]\d{7}$/,
    phonePlaceholder: 'xxx-xxxx-xx',
    phoneLength: 11,
    download: 'https://play.google.com/store/apps/details?id=com.loan.credit.cash.borrow.mangucash&hl=en',
    termsOfUse: 'https://mangucash.com/terms-of-use',
    privacyPolicy: 'https://mangucash.com/privacy-policy',
    i18n: 'en_US',
    header: {
      App_id: 'com.loan.credit.cash.borrow.mangucash',
      strategy: 'default',
      distinctId,
    },
    params: {
      appId: 'com.loan.credit.cash.borrow.mangucash',
      appName: 'ManguCash',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_ml0kMmdyocQ6dXJlv3HnNiebAseiZyxj',
  },
  {
    name: 'quicksente',
    appName: 'QuickSente',
    country: 'UG',
    areaCode: '256',
    regexp: /^7[0|4|5|6|7|8]\d{7}$/,
    phonePlaceholder: 'xxx-xxxx-xx',
    phoneLength: 11,
    download: 'https://play.google.com/store/apps/details?id=com.fast.quickloan.sente.digital.instant&hl=en',
    termsOfUse: 'https://quicksente.com/terms-of-use',
    privacyPolicy: 'https://quicksente.com/privacy-policy',
    i18n: 'en_US',
    header: {
      App_id: 'com.fast.quickloan.sente.digital.instant',
      strategy: 'default',
      distinctId,
    },
    params: {
      appId: 'com.fast.quickloan.sente.digital.instant',
      appName: 'QuickSente',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
  },
  {
    name: 'isolez',
    appName: 'iSolez',
    country: 'PE',
    areaCode: '51',
    regexp: /^[9]\d{8}$/,
    phoneLength: 11,
    phonePlaceholder: 'xxx-xxxx-xx',
    download: 'https://play.google.com/store/apps/details?id=com.sol.centimo.fast.credito.fast.efectivo.prestamos.peru&hl=None',
    termsOfUse: 'https://isolez.cc/terms-of-use',
    privacyPolicy: 'https://isolez.cc/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.sol.centimo.fast.credito.fast.efectivo.prestamos.peru',
      'Accept-Language': 'es',
      App_name: 'iSolez',
      strategy: 'default',
      distinctId,
    },
    params: {
      appId: 'com.sol.centimo.fast.credito.fast.efectivo.prestamos.peru',
      appName: 'iSolez',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_kpZoWucUpZVf0YGhaeVIuoeaFwmAKW2z',
  },
  {
    name: 'caja',
    appName: 'C Platinka',
    country: 'PE',
    areaCode: '51',
    regexp: /^[9]\d{8}$/,
    phoneLength: 11,
    phonePlaceholder: 'xxx-xxxx-xx',
    download: 'https://play.google.com/store/apps/details?id=com.loan.cajaplatinka&hl=None',
    termsOfUse: 'https://cplatinka.com/terms-of-use',
    privacyPolicy: 'https://cplatinka.com/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.loan.cajaplatinka',
      'Accept-Language': 'es',
      App_name: 'caja',
      strategy: 'default',
      distinctId,
    },
    params: {
      appId: 'com.loan.cajaplatinka',
      appName: 'caja',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_kpZoWucUpZVf0YGhaeVIuoeaFwmAKW2z',
  },

  // 哥伦比亚
  {
    name: 'parcecredit',
    appName: 'ParceCredit',
    country: 'CO',
    areaCode: '57',
    regexp: /^3(([0-4][0-9])|(5[0-1]))\d{7}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.cash.loan.credito.prestamo.parce.credit.dinero.efectivo&hl=None',
    termsOfUse: 'https://parcecredit.com/terms-of-use',
    privacyPolicy: 'https://parcecredit.com/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.cash.loan.credito.prestamo.parce.credit.dinero.efectivo',
      'Accept-Language': 'es',
      App_name: 'ParceCredit',
      strategy: 'default',
      distinctId,
    },
    params: {
      appId: 'com.cash.loan.credito.prestamo.parce.credit.dinero.efectivo',
      appName: 'ParceCredit',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_kpZoWucUpZVf0YGhaeVIuoeaFwmAKW2z',
  },

  {
    name: 'credifio-co',
    appName: 'Credifio',
    country: 'CO',
    areaCode: '57',
    regexp: /^3(([0-4][0-9])|(5[0-1]))\d{7}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=com.cash.loan.credito.prestamo.parce.credit.dinero.efectivo&hl=None',
    termsOfUse: 'https://credifio.cc/terms-of-use',
    privacyPolicy: 'https://credifio.cc/privacy-policy',
    i18n: 'es_MX',
    header: {
      App_id: 'com.cash.loan.credifio.prestamo',
      'Accept-Language': 'es',
      App_name: 'Credifio',
      strategy: 'default',
      distinctId,
    },
    params: {
      appId: 'com.cash.loan.credifio.prestamo',
      appName: 'Credifio',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_kpZoWucUpZVf0YGhaeVIuoeaFwmAKW2z',
  },

  // 墨西哥 工资贷
  {
    name: 'tifi',
    appName: 'Tifi',
    country: 'MX',
    areaCode: '52',
    regexp: /\d{10}$/,
    phoneLength: 12,
    phonePlaceholder: 'xxx-xxxx-xxx',
    download: 'https://play.google.com/store/apps/details?id=mx.com.tifi.credito&hl=None',
    termsOfUse: 'https://tifi.com.mx/condiciones',
    privacyPolicy: 'https://tifi.com.mx/avisoprivacidad',
    i18n: 'es_MX',
    header: {
      App_id: 'mx.com.tifi.credito',
      'Accept-Language': 'es',
      strategy: 'default',
      App_name: 'Tifi',
      distinctId,
    },
    params: {
      appId: 'mx.com.tifi.credito',
      appName: 'Tifi',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: '',
  },
  {
    name: 'tifi-ke',
    appName: 'Tifi',
    country: 'KE',
    areaCode: '254',
    regexp: /^[7|1]\d{8}$/,
    phoneLength: 11,
    i18n: 'en_US',
    phonePlaceholder: 'xxx-xxxx-xx',
    download: 'https://play.google.com/store/apps/details?id=ke.co.tifi.credit&hl=None',
    termsOfUse: 'https://tifi.co.ke/condiciones',
    privacyPolicy: 'https://tifi.co.ke/avisoprivacidad',
    header: {
      App_id: 'ke.co.tifi.credit',
      'Accept-Language': 'en',
      strategy: 'default',
      App_name: 'Tifi',
      distinctId,
    },
    params: {
      appId: 'ke.co.tifi.credit',
      appName: 'Tifi',
      registerChannel: 'h5',
      appVersion: '1.0.0',
    },
    branchKey: 'key_live_gd1qscWVWMz4Cfawe5DWzcoeyEdpEJAG',
  },
]

// 官网 - App的对应关系
export const Domain2App = {
  // 墨西哥
  'ipeso.cc': 'iPeso',
  'kabilcash.com': 'KabilCash',
  'creavicash.com': 'CreaviCash',
  'maxcredito.cc': 'MaxCredito',
  'xcredito.cc': 'XCredito',
  'xfectivo.com': 'XFectivo',
  'icredito.cc': 'ICredito',  // 原5号包 更名为xcredito

  // 秘鲁
  'isolez.cc': 'iSolez',
  'cajaplatinka.com': 'Caja',

  //哥伦比亚
  'ParceCredit.com': 'ParceCredit',
  'credifio.cc': 'Credifio',

  // 墨西哥工资借贷包

  'mcredito.cc': 'MCredito',
  'justocredito.com': 'JustoCredito',

  // 尼日利亚
  'credit9ja.cc': 'Credit9ja',
  'xcredit.cc': 'XCredit',
  'imoney.ng': 'iMoney',
  '9jacash.cc': '9jaCash',
  'nownowmoney.cc': 'nownowmoney',

  // 乌干达
  'ucredit.cc': 'UCredit',
  'iSente.cc': 'iSente',

  // 肯尼亚
  'kashway.cc': 'Kashway',
  'ipesa.cc': 'Ipesa',
  'creditmoja.com': 'Creditmoja',

  // 风控数据包
  'mocash.cc': 'MoCash',

  // 工资贷
  'tifi.com.mx': 'Tifi',
  'tifi.co.ke': 'Tifi',
}
